import { type ReactNode, memo } from 'react'

import { HcContainer } from '@hotmart-org-ca/cosmos-web/dist/react/hc-container'
import { HcStructureContent } from '@hotmart-org-ca/cosmos-web/dist/react/hc-structure'
import styled from 'styled-components'

type ContentProps = {
  children: ReactNode
  className?: string
  id?: string
}

const StructureContent = styled(HcStructureContent)`
  --hc-container-max-width: 100vw;
`

const Content = ({ children, className, id = '' }: ContentProps) => {
  return (
    <StructureContent slot='content'>
      <HcContainer>
        <main className={className} id={id}>
          {children}
        </main>
      </HcContainer>
    </StructureContent>
  )
}

export default memo(Content)
